import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ReviewModalProduct {
  sku?: string;
  baseCode?: string;
  name?: string;
  orderNumber?: string;
  orderId?: number | string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
}

export interface ReviewModalState {
  isOpen: boolean;
  product: ReviewModalProduct | null;
}

const initialState: ReviewModalState = {
  isOpen: false,
  product: null
};

const reviewModalSlice = createSlice({
  name: 'reviewModal',
  initialState,
  reducers: {
    openReviewModal: (
      state,
      action: PayloadAction<ReviewModalProduct | undefined>
    ) => {
      state.isOpen = true;
      state.product = action.payload ?? null;
    },
    closeReviewModal: (state) => {
      state.isOpen = false;
      state.product = null;
    }
  }
});

export const { openReviewModal, closeReviewModal } = reviewModalSlice.actions;

export default reviewModalSlice.reducer;
